import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'TableFilterMultiple'
})
export class TablefilterMultiplePipe implements PipeTransform {

  transform(items: any[], fields: any[], value: string): any[] {

    if (!items) return [];
    if (!fields) return [];
    if (!value || value.length == 0) return items;
    
    let tempArray: any[] = [];
    let uniqueArray: any[] = [];

    for(const field of fields) {
      let filteredArray
      if(field=="orderNo"){
        filteredArray = items.filter(it => 
          it["orderNo"] != null ? (it["orderNo"]+it["orderSuffix"]).trim().toLowerCase().indexOf(value.trim().toLowerCase()) !=-1 : it["orderNo"]+it["orderSuffix"]);
      }else if (field.includes('stockLine')){
        filteredArray = items.filter(it =>
          it['stockLines'] != null ? it['stockLines'].some((sl:string) => 
            sl[field.split('.')[1]] != null ? sl[field.split('.')[1]].trim().toLowerCase().indexOf(value.trim().toLowerCase()) != -1 : sl[field.split('.')[1]]
            ) : it['stockLines']
          );
      }else{
        filteredArray = items.filter(it => 
          it[field] != null ? it[field].toLowerCase().indexOf(value.trim().toLowerCase()) !=-1 : it[field]);
      }

      tempArray = tempArray.concat(filteredArray);
  
    }
    //check the duplicated items
    uniqueArray = tempArray.filter(function(item, pos) {
      return tempArray.indexOf(item) == pos;
    });

    return uniqueArray;

  }

}
